<formly-form
    [form]="form"
    [fields]="ignoreRequired ? fieldsNoRequired : fields"
    [model]="data"></formly-form>
